import { NgModule } from '@angular/core';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { BmsjHipsterSharedModule } from '../shared';
import { RouterModule } from '@angular/router';
import { SINGLE_SITE_ANALYSIS_ROUTES } from './single-site-analysis.route';
import { SingleSiteAnalysisComponent } from './single-site-analysis.component';
import { SingleSiteAnalysisContext } from './single-site-analysis.context';
import { SingleSiteAnalysisService } from './single-site-analysis.service';
import { SingleSiteAnalysisImportComponent, SingleSiteAnalysisImportPopupComponent } from './single-site-analysis-import.component';
import { HelpLinkComponent } from '../shared/help-link/help-link.component';

@NgModule({
    declarations: [
        SingleSiteAnalysisImportComponent,
        SingleSiteAnalysisImportPopupComponent,
        SingleSiteAnalysisComponent
    ],
    providers: [
        SingleSiteAnalysisService,
        SingleSiteAnalysisContext
    ],
    imports: [
        DragDropModule,
        BmsjHipsterSharedModule,
        RouterModule.forChild(SINGLE_SITE_ANALYSIS_ROUTES),
        HelpLinkComponent
    ]
})
export class SingleSiteAnalysisModule {
}
